// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"112":"4983ec9f","179":"92b1cfb4","213":"0c8f1caa","219":"a11411ed","367":"880ab16a","445":"876f91c2","453":"d1fa110c","547":"89fc4f6c","624":"8306519f","676":"2dc3e4bd","732":"74d40df9","824":"6c721a7a","955":"9fc1950d"}[chunkId] + ".chunk.js";
};